export const  CHECK_PASSWORD_LINK = 'claris-vnext/RestorePassword/CHECK_PASSWORD_LINK';